import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e54b34a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e54b34a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54b34a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e54b34a4')) {
      api.createRecord('e54b34a4', component.options)
    } else {
      api.reload('e54b34a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e54b34a4&scoped=true", function () {
      api.rerender('e54b34a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/etower/MainCont/SearchAndResults/components/CopyDialog/index.vue"
export default component.exports